import { ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ILegalPersonInformationBaseViewModel } from 'viewModels';
import { useAuth } from './auth';

type InformationBaseContextProps = {
  children: ReactNode;
};
interface IInitialValues {
  dataInformationBaseLegalPerson: ILegalPersonInformationBaseViewModel | undefined;
  setDataInformationBaseLegalPerson: React.Dispatch<
    React.SetStateAction<ILegalPersonInformationBaseViewModel | undefined>
  >;
}
const InformationBaseContext = createContext({} as IInitialValues);

const InformationBaseContextProvider = ({ children }: InformationBaseContextProps) => {
  const { tokenIsValid } = useAuth();
  const [dataInformationBaseLegalPerson, setDataInformationBaseLegalPerson] =
    useState<ILegalPersonInformationBaseViewModel>();

  useEffect(() => {
    if (!tokenIsValid) {
      setDataInformationBaseLegalPerson(undefined);
    }
  }, [tokenIsValid]);

  const contextValues = useMemo(
    () => ({ dataInformationBaseLegalPerson, setDataInformationBaseLegalPerson }),
    [dataInformationBaseLegalPerson],
  );
  return (
    <InformationBaseContext.Provider value={contextValues}>
      {children}
    </InformationBaseContext.Provider>
  );
};
export const useInformationBase = () => useContext(InformationBaseContext);
export default InformationBaseContextProvider;
